import autocomplete from 'accessible-autocomplete';
import { generateSuggestions } from './suggestions';
import spanSubstring from './dom-utils';
import generateSlug from './format-slug';

const SEARCH_PLACEHOLDER_TEXT = `Search for a company name`;
const SEARCH_NO_RESULTS_TEXT = `Sorry, we don't have a page on that company right now.`;

const init = () => {
    const entryElement = document.querySelector('.md-company-search-component__autocomplete');

    const companies = window.DataPres.getData('company-search-data');

    const generateHref = company => {
        const topicId = company.topicId;
        const slug = generateSlug(company.name);

        return `//bbc.co.uk/news/topics/${topicId}/${slug}`
    };

    const navigateTo = company => {
        window.location.href = generateHref(company);
    };

    const findCompany = name => {
        return companies.filter((company) => company.name === name)[0];
    };

    const generateSuggestion = name => {
        const inputElementValue = document.getElementById('md-company-search-component-input').value;
        return spanSubstring(name, inputElementValue);
    }

    const autocompleteSource = (query, populateSuggestions) => {
        const data = companies.map(company => company.name);
        const suggestions = generateSuggestions(data, query);

        populateSuggestions(suggestions);
    }

    autocomplete({
        element: entryElement,
        id: 'md-company-search-component-input', // To match it to the existing <label>.
        cssNamespace: 'md-company-search-component',
        source: autocompleteSource,
        confirmOnBlur: false,
        displayMenu: 'overlay',
        minLength: 2,
        autoselect: false,
        placeholder: SEARCH_PLACEHOLDER_TEXT,
        tNoResults: () => SEARCH_NO_RESULTS_TEXT, // visually displayed in list
        tStatusNoResults: () => SEARCH_NO_RESULTS_TEXT, // read by screenreaders
        onConfirm: (companyName) => navigateTo(findCompany(companyName)),
        templates: {
            suggestion: (companyName) => generateSuggestion(companyName),
        },
    });
};

const hideEnhancedElements = () =>  {
    const containerElement = document.querySelector('.md-company-search-component__search');
    containerElement.className += ' md-company-search-component--hidden'
}

if (window.DataPres.enhanced === true) {
    init();
}
else {
    hideEnhancedElements();
}


// WEBPACK FOOTER //
// ./js/component.js